import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import EmploymentHistory from './components/EmploymentHistory';
import Qualifications from './components/Qualifications';
import ProjectList from './components/Projects';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

function Home() {
  return (
    <>
      <title>Travis Wylie - Home</title>
      <div className="page">
        <h1 className="mb-4">Hello, world!</h1>
        <p>My name is Travis Wylie, I am a software developer currently seeking a new opportunity.</p>

        <br />
        <p>With 7 years of professional software development experience on top of having completed freelance work and mentoring, I have contributed to the development of many kinds of different applications while still finding time to continue with my own projects.</p>
        <p>Since 2024 I have maintained and repaired my own FDM and resin 3D printers, and I build, upgrade and repair PCs and run Linux servers, so I am as comfortable with a machine open on the bench as I am with the firmware and software running on it.</p>
        <p>In my previous employment, I have been responsible for aiding the training of new staff members both locally and remote, while creating additional applications to help colleagues with timekeeping. As a result, time logs were more accurate and less time was taken to keep these logs as the software integrated with company systems by API.</p>
        <p>I have also had experience working remotely using time management skills and communication to assist collegues with various tasks while working on projects in varying timezones.</p>
        <p>I am currently seeking an employment opportunity that would allow me to utilize my current experience and continue to grow into new and exciting roles.</p>
        <br />

        <h2 className="mb-3">Blazor portfolio:</h2>
        <p>I also have a web portfolio made with Blazor:</p>

        <div className="text-center m-4">
          <Button 
            variant="primary" 
            href="https://traviswylie.co.nz"
            download
            className="download-cv-btn"
          >
            <i className="bi bi-download"></i> Go to Blazor Site
          </Button>
        </div>

        <br />

        <h2 className="mb-3">CV:</h2>
        <p>You can view my paper CVs through the following links:</p>

        <div className="text-center m-4">
          <Button 
            variant="primary" 
            href="https://drive.google.com/file/d/1tDHiBeaDQXg8N4GZfSC6oSyP4ae8egjP/view?usp=sharing"
            download
            className="download-cv-btn"
          >
            <i className="bi bi-download"></i> Software Development CV
          </Button>
        </div>
        
        <div className="text-center m-4">
          <Button 
            variant="primary" 
            href="https://drive.google.com/file/d/1nRXbgScOzY6hkq79hkhYyBMh5uMcrOBT/view?usp=sharing"
            download
            className="download-cv-btn"
          >
            <i className="bi bi-download"></i> 3D Printer Technician CV
          </Button>
        </div>

        <div className="text-center m-4">
          <Button 
            variant="primary" 
            href="https://drive.google.com/file/d/122lijuOvJmxpqTaf9b0mmlMhPJK4Rt6h/view?usp=sharing"
            download
            className="download-cv-btn"
          >
            <i className="bi bi-download"></i> IT Technician CV
          </Button>
        </div>
        

        <br />
        <br />
        <p><i>A self hosted AI model was used in the creation of this site.</i></p>
      </div>
    </>
  );
}

function Experience() {
  return (
    <>
      <title>Travis Wylie - Experience</title>
      <div className="page">
        <h1 className="mb-4">Experience</h1>
        <p className="mb-5">Professional journey and skills.</p>
        <EmploymentHistory />
        <Qualifications />
      </div>
    </>
  );
}

function Projects() {
  return (
    <>
      <title>Travis Wylie - Projects</title>
      <div className="page">
        <h1 className="mb-4">Projects</h1>
        <p>My recent work and projects.</p>
        <ProjectList />
      </div>
    </>
  );
}

function ContactPage() {
  return (
    <>
      <title>Travis Wylie - Contact</title>
      <div className="page">
        <h1 className="mb-4">Contact Me</h1>
        <p>For any questions, references or additional code samples, please contact me through one of the following methods:</p>
        <Contact />
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <div className="app-container col-md-10">
          <main className="content-area flex-grow-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
            <hr />
            <p className="footer"><i>Travis Wylie - 2026</i></p>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
